import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Body, H5} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"
import {PointsRequest} from "."
import styled, {css} from "styled-components"
interface Props {
  onSendNewRequest: () => void
  pointsRequest: PointsRequest
}
const StyledRequestContainer = styled(Flex)`
  ${({theme}) => css`
    background: ${theme.colors.greys.grey03};
    flex-direction: column;
    border-radius: ${theme.spacing.one};
    padding: ${theme.spacing.oneAndHalf};
  `}
`
const FieldsToRender = [
  {
    name: "budget",
    label: "wallet.reward.requestPoints.label.budget",
    transformer: (pointsRequest: PointsRequest) => pointsRequest.budget.name
  },
  {
    name: "approver",
    label: "wallet.reward.requestPoints.label.approver",
    transformer: (pointsRequest: PointsRequest) => `${pointsRequest.approver.firstName} ${pointsRequest.approver.lastName}`
  },
  {
    name: "pointsRequest",
    label: "wallet.reward.requestPoints.placeholder.requestAmount",
    transformer: (pointsRequest: PointsRequest) => pointsRequest.pointsRequest
  },
  {
    name: "reason",
    label: "wallet.reward.requestPoints.label.reason",
    transformer: (pointsRequest: PointsRequest) => pointsRequest.reason
  }
]
const RequestPointsSuccess = (props: Props) => {
  const {pointsRequest, onSendNewRequest} = props
  return (
    <Flex direction="column" gap={2}>
      <Body>
        <FormattedMessage id="wallet.reward.budget.rewardWallet.subtitle.requestPointsSuccess" />
      </Body>
      <StyledRequestContainer>
        {FieldsToRender.map(({name, label, transformer}) => (
          <Flex key={name} marginBottom={2} direction="column" gap={1}>
            <H5 weight="bold">
              <FormattedMessage id={label} />
            </H5>
            <Body small>{transformer(pointsRequest)}</Body>
          </Flex>
        ))}
      </StyledRequestContainer>
      <Button full primary marginTop={3} onClick={onSendNewRequest}>
        <FormattedMessage id="wallet.reward.requestPoints.btn.newRequestPoints" />
      </Button>
    </Flex>
  )
}

export default RequestPointsSuccess
